module.exports = __webpack_public_path__ + "static/media/WhitneySSm-Light-Adv_Web.7e873af3.woff";